module.exports = __webpack_public_path__ + "images/TrelloGoldBadge.3165e93a7df78639d858.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/TrelloGoldBadge.png
// module id = j3qa
// module chunks = 24